import { createAsyncThunk } from '@reduxjs/toolkit';
import { _studyResearchUrls } from '@custom/Utils/constants/apiUrls';

 const updateStudyResearch = createAsyncThunk(
  'studyResearch/updateStudyResearch',
  async (payload, { rejectWithValue }) => {
    const url = _studyResearchUrls.update;
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      if (!response?.ok) {
        return rejectWithValue(`Failed to update research data. Status code: ${response?.status}`);
      }

      return await response.json();

    } catch (error) {
      return rejectWithValue(`Failed to update research data. Status code: ${error}`);
    }
  }
);

export default updateStudyResearch;
